import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import { strEllipsis } from 'utils/cuttext';
import themes from 'styles/themes';

const useStyles = makeStyles(() => ({
    formControl: {
        '& .MuiInputBase-root': {
            color: '#6EC177',
            minWidth: '60px',
            justifyContent: 'flex-end',
            alignItems: 'center',
        },
        '& .MuiSelect-select.MuiSelect-select': {
            paddingRight: '0px',
        },
        marginLeft: 6,
    },
    select: {
        width: 'auto',
        fontSize: '14px',
        padding: '0 4px 0 0 !important',
        fontWeight: 400,
        fontFamily: 'PoppinsRegular',
        color: themes.palette.primary.main,
        '&:focus': {
            backgroundColor: 'transparent',
        },
    },
    selectIcon: {
        position: 'relative',
        color: themes.palette.primary.main,
        fontSize: '14px',
    },
    paper: {
        borderRadius: 12,
        marginTop: 8,
    },
    list: {
        paddingTop: 0,
        paddingBottom: 0,
        minHeight: 'auto',
        '& li': {
            fontWeight: 400,
            paddingTop: 2,
            paddingBottom: 2,
            fontSize: 14,
            fontFamily: 'PoppinsRegular',
        },
        '& li.Mui-selected': {
            color: 'black',
            background: themes.palette.secondary['500'],
        },
        '& li.Mui-selected:hover': {
            background: '#E8F0F1',
        },
    },
}));

const DropDown = ({ value, handleChange, items }) => {
    const classes = useStyles();
    const [data, setData] = useState(items);
    useEffect(() => {
        if (items && items.length > 0) {
            setData(
                items.map((d) => {
                    return {
                        // key : d,
                        // value : d
                        ...d,
                    };
                }),
            );
        } else {
            setData([]);
        }
    }, [items]);
    // console.log(data);
    return (
        <FormControl className={classes.formControl}>
            <Select
                value={value}
                onChange={handleChange}
                disableUnderline
                IconComponent={ExpandMoreRoundedIcon}
                MenuProps={{
                    classes: {
                        list: classes.list,
                        paper: classes.paper,
                    },
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'center',
                    },
                    getContentAnchorEl: null,
                }}
                classes={{
                    select: classes.select,
                    icon: classes.selectIcon,
                }}
            >
                {/* <MenuItem value="">
                    Select
                </MenuItem> */}
                {data?.map((item, index) => (
                    <MenuItem key={index} value={item.value}>
                        {strEllipsis(item.title, 20)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default DropDown;
